import { COMMON_TEXT } from "@/constants/text";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_TableOptions,
  useMantineReactTable,
} from "mantine-react-table";

interface MantinePanelTableProps<TData extends Record<string, any>>
  extends MRT_TableOptions<TData> {
  columns: MRT_ColumnDef<TData>[];
  data: TData[];
}

export const MantinePanelTable = <TData extends Record<string, any>>({
  columns,
  data,
  ...props
}: MantinePanelTableProps<TData>) => {
  const table = useMantineReactTable<TData>({
    columns,
    data: data,
    enableRowNumbers: false,
    enableColumnActions: false,
    enableColumnOrdering: false,
    enableSorting: false,
    enableTopToolbar: false,
    enablePagination: false,
    enableBottomToolbar: false,
    enableRowActions: false,
    positionActionsColumn: "last",
    mantineTableBodyRowProps: (row) => ({
      sx: {
        color: "#FFFFFF",
        cursor: "pointer",
        "&:hover": {
          color: "#000000",
        },
        backgroundColor: "#161B21",
      },
    }),
    localization: {
      noRecordsToDisplay: COMMON_TEXT.DATA_EMPTY.NO_DATA,
    },
    mantineTableHeadCellProps: {
      bg: "#161B21",
      style: {
        color: "gray",
      },
      sx: {
        border: "1px solid white !important",
      },
    },
    mantineTableBodyCellProps: () => {
      return {
        bg: "#161B21",
        sx: {
          border: "1px solid white !important",
        },
      };
    },
    mantineTableProps: {
      sx: {
        backgroundColor: "#161B21",
      },
    },
    enableStickyHeader: true,
    ...props,
    defaultColumn: {
      size: 10,
    },
  });

  return <MantineReactTable table={table} />;
};
